export const SIMPLE_SELECT = 'Simple Select';
export const MULTIPLE_CHOICE = 'Multiple Choice';
export const RATING_SCALE = 'Rating Scale';
export const OPEN = 'Open';